import { LoadingType } from '@/types/components/loading';
import { acceptHMRUpdate, defineStore } from 'pinia';

const initialState: LoadingType = {
  show: false,
};

export const useLoadingStore = defineStore('loading.store', {
  state: (): LoadingType => ({ ...initialState }),
  getters: {
    isShow: (state: LoadingType) => !!state.show,
  },
  actions: {
    showLoading() {
      this.show = true;
      document.body.style.overflow = 'hidden';
    },
    hideLoading() {
      this.show = false;
      document.body.style.overflow = 'unset';
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useLoadingStore, import.meta.hot));
}
